import React from "react";
import StyleButton from "./StyleButton";

let Element = (props) => {

    return <span>
        { props.controls.map (type =>
            <StyleButton
                key={ type.label }
                label={ type.label }
                onToggle={ () => props.onToggle (type.label) }
                icon={ type.icon }
                isDisabled={props.isDisabled}
            />
        ) }
    </span>
}

export default Element